<div class="app-loader overflow-hidden bulk-edit-progress-overlay">
	<div class="loader-wrapper">
		<div class="loader-content">
			<div class="bulk-edit-progress-overlay__panel">
				<div class="bulk-edit-progress-overlay__percent">{{ displayPercent }}%</div>
				<mat-progress-bar
					[value]="displayPercent"
					color="primary"
					mode="determinate"
				></mat-progress-bar>
				<p
					*ngIf="failed > 0"
					class="bulk-edit-progress-overlay__failed"
					role="status"
				>
					{{ failedLabelKey | translate: { count: failed } }}
				</p>
				<div class="bulk-edit-progress-overlay__phase">
					<span class="bulk-edit-progress-overlay__phase-label">{{ phaseLabel }}</span>
					<span
						aria-hidden="true"
						class="bulk-edit-progress-overlay__phase-dots"
						>{{
							dotsText
						}}</span
					>
				</div>
			</div>
		</div>
	</div>
</div>
